import { Icon } from "@chakra-ui/react";
import React from "react";

/**
 * Renders the exterior camera icon
 * 
 * @param {Object} props - The props of the component
 * @returns The exterior camera icon
 */
const ExteriorCameraIcon = (props) => (
  <Icon viewBox="0 0 19 15" fill="none" {...props}>
    <path d="M2.82675 11.3652H12.173L9.06925 7.2885L6.69225 10.327L5.123 8.38475L2.82675 11.3652ZM1.8075 15C1.3025 15 0.875 14.825 0.525 14.475C0.175 14.125 0 13.6974 0 13.1923V1.80775C0 1.30258 0.175 0.875 0.525 0.525C0.875 0.175 1.3025 0 1.8075 0H13.1923C13.6973 0 14.1248 0.175 14.4747 0.525C14.8247 0.875 14.9998 1.30258 14.9998 1.80775V6.38475L18.519 2.8655V12.1345L14.9998 8.61525V13.1923C14.9998 13.6974 14.8247 14.125 14.4747 14.475C14.1248 14.825 13.6973 15 13.1923 15H1.8075ZM1.8075 13.5H13.1923C13.2819 13.5 13.3556 13.4712 13.4133 13.4135C13.4711 13.3558 13.5 13.2821 13.5 13.1923V1.80775C13.5 1.71792 13.4711 1.64417 13.4133 1.5865C13.3556 1.52883 13.2819 1.5 13.1923 1.5H1.8075C1.71783 1.5 1.64417 1.52883 1.5865 1.5865C1.52883 1.64417 1.5 1.71792 1.5 1.80775V13.1923C1.5 13.2821 1.52883 13.3558 1.5865 13.4135C1.64417 13.4712 1.71783 13.5 1.8075 13.5Z" fill="currentColor" />
  </Icon>
);

export default React.memo(ExteriorCameraIcon);
